import React, { Component } from 'react';
import NotepadPopup from "./NotepadPopup";
import Buddiesnotes from "./Buddiesnotes";
const $=window.$;
const win=window;
const jQuery=window.jQuery;

class Allnotes extends Component {
    constructor(props) {
        super(props);
        this.state={
            popupBlock:null
        };

    } 
    
    time(){
        return Math.floor((new Date()).getTime() / 1000);
    }
    
    showData(index,data,room_name,name,learner){

     
       
            this.setState({
                popupBlock:<NotepadPopup key={`notes_${index}`} data={data} room_name={room_name} name={name} learner={learner}  />
            })
       

        
    }

    openlrBlock(index){
        let block=$("div[id^=tr_lr_dlr_]");

        $(block).each(function(){
            $(this).hide();
        });

        $("#tr_lr_dlr_"+index).show();
        
        
    }

    render () {
        const {data,buddies}=this.props;
       
        return (
            <div className="tabgrey">
            {this.state.popupBlock}
            <div id="sharedlr_view">
                <h2 className="bluetxt seek-head">My Notes</h2>
                
                            <div  >
    
                       
                           {data.lr_mynotes!=undefined &&
                            <div>
                            {Object.keys(data.lr_mynotes).length>0  &&
                            <div className="buddies-lr">
                                <div className="roomtit"><strong>LR's</strong></div>
                                {data.lr_mynotes.map((val,index)=>
                                 <div key={index} className="roomno">
                                 <a className="lr_linkd" onClick={(e)=>this.showData(this.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name)} href="javascript:void(0);" >{val.name}</a>
                                 
                                 </div>
                                )}
                                </div>
                               }
                            </div>
                            }
                          

                          {data.dLr_mynotes!=undefined &&
                           <div>
                            {Object.keys(data.dLr_mynotes).length>0  &&
                            <div className="buddies-lr">
                                <div className="roomtit"><strong>DLR's</strong></div>
                                {data.dLr_mynotes.map((val,index)=>
                                 <div key={index} className="roomno">
                                  <a className="dlr_linkd" onClick={(e)=>this.showData(this.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name)} href="javascript:void(0);" >{val.name}</a>
                                 </div>
                                )}
                                </div>
                               }
                            </div>
                            }

                        {(data.dLr_mynotes!=undefined && data.lr_mynotes!=undefined) &&
                            <div>
                            {(Object.keys(data.dLr_mynotes).length>0 && Object.keys(data.lr_mynotes).length>0) &&
                            <div align="center">No notes found.</div>
                            }
                            </div>
                        }

            {buddies!=undefined &&
            <div className="buddies-lr1">
            <h2 className="bluetxt seek-head">Buddies</h2>
            <div id="divSharedlr"></div>
            {Object.keys(buddies).length>0  &&
            <div>
            {buddies.map((key,index)=>
                <div key={index} className="buddieslist">
                    <a href="javascript:void(0);" onClick={(e)=>this.openlrBlock(index)} className="title_orange">
                       {key.learner_name}
                    </a>
                    <div id={`tr_lr_dlr_${index}`} style={{display:"none"}}>
                    {key.lr_mynotes!=undefined &&
                            <div>
                            {key.lr_mynotes!=null  &&
                            <div className="buddies-lr">
                                <div className="roomtit"><strong>LR's</strong></div>
                                {key.lr_mynotes.map((val,index)=>
                                 <div key={index} className="roomno">
                                 <a className="lr_linkd" onClick={(e)=>this.showData(this.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name)}  href="javascript:void(0);" >{val.name}</a>
                                 
                                 </div>
                                )}
                                </div>
                               }
                            </div>
                            }
                          

                          {key.dLr_mynotes!=undefined &&
                           <div>
                            {key.dLr_mynotes!=null  &&
                            <div className="buddies-lr">
                                <div className="roomtit"><strong>DLR's</strong></div>
                                {key.dLr_mynotes.map((val,index)=>
                                 <div key={index} className="roomno">
                                  <a className="dlr_linkd" onClick={(e)=>this.showData(this.time()+"_"+val.name,val.data,val.room_name,val.name,data.learner_name)}  href="javascript:void(0);" >{val.name}</a>
                                 </div>
                                )}
                                </div>
                               }
                            </div>
                            }

                        {(key.dLr_mynotes!=undefined && key.lr_mynotes!=undefined) &&
                            <div>
                            {(key.dLr_mynotes==null && key.lr_mynotes==null) &&
                            <div align="center">No notes found.</div>
                            }
                            </div>
                        }
                    </div>
                </div>
            )}
             </div>
            }

        </div>
        }
                     
                    </div>
               
            </div>
            </div>
        )
    }
}

export default Allnotes


// WEBPACK FOOTER //
// ./src/lr_dlr_components/notepad_partials/Allnotes.js